<div class="nav-drawer-mobile" *ngIf="isOpen" @effect>
  <div><ng-content></ng-content></div>
</div>
